/**
 * Shared trigger store for the single {@link RecordingSetupPrompt}.
 *
 * @remarks
 * One setup prompt is rendered per top-level camera view; the top-level
 * encryption orchestrator ({@link ensureDeviceEncryption}) and the storage
 * settings UI open it through this store, so the opener and the rendered prompt
 * stay decoupled (like `camera_key_prompt`).
 */

import { writable } from 'svelte/store';

/** State of the shared recording-setup prompt. */
export interface CameraSetupPromptState {
	/** The normalised device id the prompt should set up encryption for. */
	deviceId: string;
	/** Whether the prompt is open. */
	open: boolean;
}

const initialState: CameraSetupPromptState = { deviceId: '', open: false };

function create_camera_setup_prompt() {
	const { subscribe, set, update } = writable<CameraSetupPromptState>({ ...initialState });

	return {
		subscribe,
		/** Opens the shared setup prompt for a device. */
		open: (deviceId: string) => set({ deviceId, open: true }),
		/** Closes the prompt but keeps the last device id (harmless once hidden). */
		close: () => update((state) => ({ ...state, open: false })),
	};
}

export const camera_setup_prompt = create_camera_setup_prompt();
